// Keeps the phone's screen on while the viewer holds a seat. A phone that
// sleeps drops its socket, and a seated llama that misses a guess is booted.
// The browser releases the lock when the tab is hidden, so it is asked for
// again when the tab comes back. Where the API is missing, nothing happens.

let wanted = false;
let held: WakeLockSentinel | null = null;

async function take(): Promise<void> {
  if (!wanted || held !== null || document.visibilityState !== 'visible') return;
  try {
    held = await navigator.wakeLock.request('screen');
    held.addEventListener('release', () => {
      held = null;
    });
  } catch {
    // Not supported, low battery mode, or not allowed. The page still works.
  }
}

export function keepAwake(seated: boolean): void {
  if (!('wakeLock' in navigator) || seated === wanted) return;
  wanted = seated;
  if (wanted) {
    void take();
    return;
  }
  void held?.release();
  held = null;
}

document.addEventListener('visibilitychange', () => {
  void take();
});
